import React, { createContext, useState, useContext, useEffect } from 'react';
import businessInfoService from '../services/businessInfoService';

const BusinessContext = createContext(null);

export const BusinessProvider = ({ children }) => {
  const [businessInfo, setBusinessInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBusinessInfo();
  }, []);

  const loadBusinessInfo = async () => {
    setLoading(true);
    const result = await businessInfoService.get();
    if (result.success) {
      setBusinessInfo(result.data);
    }
    setLoading(false);
  };

  const updateBusinessInfo = async (data) => {
    const result = await businessInfoService.update(data);
    if (result.success) {
      setBusinessInfo(result.data);
    }
    return result;
  };

  const value = {
    businessInfo,
    loading,
    loadBusinessInfo,
    updateBusinessInfo
  };

  return (
    <BusinessContext.Provider value={value}>
      {children}
    </BusinessContext.Provider>
  );
};

export const useBusiness = () => {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusiness debe ser usado dentro de BusinessProvider');
  }
  return context;
};

export default BusinessContext;


